/**
 * @generated SignedSource<<79b3709d39241c16e2f7aa831af18178>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EmployeeScheduleNameEmployeeNamePanel_employee$data = {
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"Avatar_employee">;
  readonly " $fragmentType": "EmployeeScheduleNameEmployeeNamePanel_employee";
};
export type EmployeeScheduleNameEmployeeNamePanel_employee$key = {
  readonly " $data"?: EmployeeScheduleNameEmployeeNamePanel_employee$data;
  readonly " $fragmentSpreads": FragmentRefs<"EmployeeScheduleNameEmployeeNamePanel_employee">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EmployeeScheduleNameEmployeeNamePanel_employee",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Avatar_employee"
    }
  ],
  "type": "Employee",
  "abstractKey": null
};

(node as any).hash = "ade605f84978b1cf28bee3528766509d";

export default node;
